import { LegacyBuyerTableFilters } from "components/buyers/useLegacyFilterableBuyerTableState";
import { QuickFilterBar as FilterBar } from "components/form_components/QuickFilterBar";
import { EventDataTypes } from "lib/tracking";
import { SortState } from "../../lib/search/types";
import { getExpandedBuyersColumnCopy } from "./utils/getBuyersColumnCopy";
import { BuyerFilterSections } from "./BuyerFilterForm";
import { TableData } from "./types";

function getAppliedFilters(filters: LegacyBuyerTableFilters): (keyof LegacyBuyerTableFilters)[] {
  const appliedFiltersArray = Object.entries(filters).filter(([_key, value]) => {
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    if (value && typeof value === "object") {
      return Object.keys(value).length > 0;
    }
    if (typeof value === "string") {
      return value.length > 0;
    }
    if (typeof value === "boolean") {
      return true;
    }
    return false;
  });

  return appliedFiltersArray.map(([key]) => key as keyof LegacyBuyerTableFilters);
}

const sectionToFilterKey: Record<BuyerFilterSections, (keyof LegacyBuyerTableFilters)[]> = {
  suppliers: ["supplierIds", "supplierSme"],
  buyerInformation: ["buyerName", "buyerGuids", "buyerTypes"],
  buyerSearch: [],
  buyerLists: ["buyerLists"],
  signals: ["signals"],
};

/**
 * @deprecated Framework buyers table needs to be refactored to use the new graphql api
 */
export function QuickFilterBarFrameworkBuyers({
  filters,
  sortState,
  onClearFilter,
  onFilterClick,
  hiddenSections,
  tableData,
  clearAllFilters,
  clearAllFiltersHide,
}: {
  filters: LegacyBuyerTableFilters;
  sortState: SortState;
  onClearFilter: (value: keyof LegacyBuyerTableFilters) => void;
  onFilterClick: (value: keyof LegacyBuyerTableFilters) => void;
  hiddenSections: BuyerFilterSections[];
  // TODO: Fetch this from react context using a hook
  tableData: TableData;
  clearAllFilters: () => void;
  clearAllFiltersHide?: () => boolean;
}) {
  const hiddenSectionFields =
    hiddenSections?.map((section) => sectionToFilterKey[section]).flat() || [];

  const appliedFiltersMapped = getAppliedFilters(filters);

  const filterKeyToLabel: Record<keyof LegacyBuyerTableFilters, string> = {
    buyerName: "Buyer name",
    signals: "Signals",
    countryCodes: "Country",
    hqCountry: "Buyer HQ",
    supplierIds: `Suppliers ${filters.supplierIds?.length}`,
    supplierSme: "SME Supplier",
    categories: "Categories",
    buyerTypes: "Buyer Type",
    buyerGuids: `Buyers (${filters.buyerGuids?.length})`,
    buyerLists: `Buyer lists (${filters.buyerLists?.length})`,
    regionIds: "Region IDs",
  };

  const {
    totalCount,
    queryResult: { isLoading },
  } = tableData;

  return (
    <FilterBar<LegacyBuyerTableFilters>
      appliedFilters={appliedFiltersMapped}
      isLoading={isLoading}
      totalResults={totalCount || 0}
      filterKeyToLabel={filterKeyToLabel}
      onClear={onClearFilter}
      onFilterClick={onFilterClick}
      sortField={getExpandedBuyersColumnCopy(sortState.field)}
      dataType={EventDataTypes.buyer}
      hiddenFields={hiddenSectionFields}
      clearAllFilters={clearAllFilters}
      clearAllFiltersHide={clearAllFiltersHide}
    />
  );
}
